@let agreement = $agreement();
<unity-card-agreement-summary-shared [agreement]="agreement">
  <h4>Remaining Award</h4>
  <h3>
    @if ($isLoading()) {
      <kendo-skeleton [width]="30" />
    } @else {
      {{ agreement?.remaining_award_amount | currency }}
    }
  </h3>
  <kendo-gridlayout gap="0.5rem" [cols]="['1fr', '1em', '1fr']" [align]="{ horizontal: 'center', vertical: 'bottom' }">
    <kendo-gridlayout-item class="k-justify-self-end">
      <div class="k-text-center">
        <h6>Award</h6>
        <h6>
          @if ($isLoading()) {
            <kendo-skeleton [width]="30" />
          } @else {
            {{ agreement?.award_amount | currency }}
          }
        </h6>
      </div>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item>
      <h6>-</h6>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item class="k-justify-self-start">
      <div class="k-text-center">
        <h6>Disbursed</h6>
        <h6>
          @if ($isLoading()) {
            <kendo-skeleton [width]="30" />
          } @else {
            {{ agreement?.total_disbursement_amount | currency }}
          }
        </h6>
      </div>
    </kendo-gridlayout-item>
  </kendo-gridlayout>
</unity-card-agreement-summary-shared>
